package raw.models

import kotlinx.serialization.Serializable

@Serializable
data class Transaction(
    val amount: Double,
    val merchantName: String? = null, // Good for UI display
    val merchantId: String? = null,   // Critical for specific merchant rules (merch_swiggy)
    val categoryId: String,           // e.g., "cat_dining"
    val channel: String               // 🟢 Strictly "ONLINE" or "OFFLINE"
)